import { useMemo } from 'react';
import { PropertiesCard } from '../../../../components/Cards/PropertiesCard';
import './DeletePartDialog.css';

const ataFormatter = (part) => ((part.ATAChapterNumber) ? (`${part.ATAChapterNumber}` + (part.ATASectionNumber ? (`-${part.ATASectionNumber}` + (part.ATAParagraphNumber ? `-${part.ATAParagraphNumber}` : '')) : '')) : '00-00-00')

const DeletePartDialog = ({ item, onClose, onDelete, message }) => {
  // const computedPart = useMemo(() => ({
  //   PN: part.partNumber,
  //   Description: part.description,
  //   Category: part.categoryName,
  //   "Sub Category": part.subCategoryName,
  //   "ATA": ataFormatter(part)
  // }), [part]);

  const deleteHandler = (e) => {
    onClose?.(e);
    onDelete?.(e);
  }

  return (<div className='delete-part-dialog-component'>
    <div className='header'>
      <span>{message}</span>
      {/* <button className='outlined icon mid-size' onClick={onClose}>
        <i className='icon-cross'></i>
      </button> */}

    </div>
    {(Object.keys(item ?? {}).length > 0 )&&<PropertiesCard singleCard object={item} className='grey'></PropertiesCard>}
    <div className='buttons'>
      <button className='filled mid-size' onClick={deleteHandler}>Ok</button>
      <button className='filled mid-size danger' onClick={onClose}>Cancel</button>
    </div>
  </div>)
}

export default DeletePartDialog;